<form [formGroup]="form">
    <div class="col-12 md:col-12">
        <p-accordion [value]="['0', '1','2','3']" [multiple]="true">
            <p-accordion-panel value="0" class="mb-2">
                <p-accordion-header>Datos personales</p-accordion-header>
                <p-accordion-content>
                    <div miForm>
                        <div class="grid nested-grid">
                            <div class="col-12 md:col-3">
                                <div miFormField class="flex justify-content-center align-items-center col-md-12 h-full">
                                    <!-- Contenedor para overlay -->
                                    <div
                                        class="avatar-wrapper"
                                        (click)="fileInput.click()"
                                        (keydown.enter)="fileInput.click()"
                                        (keydown.space)="fileInput.click()"
                                        tabindex="0"
                                        role="button"
                                        aria-label="Cambiar foto de perfil"
                                        pTooltip="Cambiar foto"
                                        tooltipPosition="top"
                                    >
                                        <p-avatar
                                            style="width: 80px; height: 80px; cursor: pointer"
                                            [image]="noPic()"
                                            class="mr-2"
                                            size="xlarge"
                                            shape="circle"
                                        >
                                        </p-avatar>

                                        <!-- Overlay con ícono (se muestra al hover) -->
                                        <div class="avatar-overlay">
                                            <i class="pi pi-camera"></i>
                                        </div>
                                    </div>

                                    <!-- Input oculto para subir imagen -->
                                    <input
                                        type="file"
                                        #fileInput
                                        accept="image/*"
                                        style="display: none"
                                        (change)="onFileSelected($event)"
                                    />
                                </div>
                            </div>

                            <div class="col-12 md:col-9 mr-0 ml-0" style="padding-left: 0.3rem" miForm>
                                <div
                                    [miCol]="4"
                                    miFormField
                                    [miFormFieldError]="getErrorMessage('tipIde', 'El tipo de identificación es requerido')"
                                >
                                    <label>Tipo de identificación *</label>
                                    <p-select
                                        [options]="identificationList"
                                        formControlName="tipIde"
                                        placeholder="Seleccione el tipo de identificación"
                                        [filter]="true"
                                        [filterBy]="'label,id'"
                                        optionLabel="label"
                                        optionValue="id"
                                        appendTo="body"
                                        [disabled]="true"
                                    ></p-select>
                                </div>

                                <div
                                    [miCol]="4"
                                    miFormField
                                    [miFormFieldError]="getErrorMessage('codEmp', 'La identificación de empleado es requerida')"
                                >
                                    <label>Identificación *</label>
                                    <input pInputText formControlName="codEmp" placeholder="Identificación de empleado" />
                                </div>

                                <div
                                    [miCol]="4"
                                    miFormField
                                    [miFormFieldError]="getErrorMessage('fecExp', 'La fecha de expedición es requerida')"
                                >
                                    <label>Fecha de expedición *</label>
                                    <p-datepicker
                                        id="fecExp"
                                        formControlName="fecExp"
                                        dateFormat="dd/mm/yy"
                                        showIcon="true"
                                        placeholder="Selecciona una fecha"
                                        appendTo="body"
                                    ></p-datepicker>
                                </div>

                                <!-- Segundo bloque -->
                                <div
                                    class="col-3"
                                    miFormField
                                    [miFormFieldError]="getErrorMessage('paiExp', 'El país de expedición es requerido')"
                                >
                                    <label>País de expedición *</label>
                                    <p-select
                                        [options]="countryList"
                                        formControlName="paiExp"
                                        placeholder="Seleccione el país de expedición"
                                        [style]="{ width: '25rem' }"
                                        [filter]="true"
                                        [filterBy]="'label,id'"
                                        optionLabel="label"
                                        optionValue="id"
                                        (onChange)="onCountryExpChange($event)"
                                        appendTo="body"
                                    ></p-select>
                                </div>

                                <div
                                    class="col-3"
                                    miFormField
                                    [miFormFieldError]="getErrorMessage('ciuExp', 'La ciudad de expedición es requerida')"
                                >
                                    <label>Ciudad de expedición *</label>
                                    <p-select
                                        [options]="departmentCitiesExpList"
                                        formControlName="ciuExp"
                                        placeholder="Seleccione la ciudad de expedición"
                                        [style]="{ width: '25rem' }"
                                        [filter]="true"
                                        [filterBy]="'label,id'"
                                        optionLabel="label"
                                        optionValue="id"
                                        appendTo="body"
                                    ></p-select>
                                </div>

                                <div
                                    class="col-3"
                                    miFormField
                                    [miFormFieldError]="getErrorMessage('rh', 'El grupo sanguíneo es requerido')"
                                >
                                    <label>Grupo sanguíneo *</label>
                                    <p-select
                                        [options]="rhList"
                                        formControlName="rh"
                                        placeholder="Seleccione el grupo sanguíneo"
                                        [style]="{ width: '25rem' }"
                                        [filter]="true"
                                        [filterBy]="'label,id'"
                                        optionLabel="label"
                                        optionValue="id"
                                        appendTo="body"
                                    ></p-select>
                                </div>
                            </div>
                        </div>

                        <!-- nombres -->
                        <div [miCol]="3" miFormField [miFormFieldError]="getErrorMessage('nom1Emp', 'El primer nombre es requerido')">
                            <label>Primer nombre*</label>
                            <input pInputText formControlName="nom1Emp" placeholder="Primer nombre" />
                        </div>

                        <div [miCol]="3" miFormField>
                            <label>Segundo nombre</label>
                            <input pInputText formControlName="nom2Emp" placeholder="Segundo nombre" />
                        </div>

                        <!-- <div [miCol]="4" miFormField></div> -->

                        <div [miCol]="3" miFormField [miFormFieldError]="getErrorMessage('ape1Emp', 'El primer apellido es requerido')">
                            <label>Primer apellido*</label>
                            <input pInputText formControlName="ape1Emp" placeholder="Primer apellido" />
                        </div>

                        <div [miCol]="3" miFormField>
                            <label>Segundo apellido</label>
                            <input pInputText formControlName="ape2Emp" placeholder="Segundo apellido" />
                        </div>

                        <!-- <div [miCol]="4" miFormField></div> -->

                        <!-- informacion de nacimiento -->

                        <div [miCol]="3" miFormField [miFormFieldError]="getErrorMessage('paiNac', 'El país de nacimiento es requerido')">
                            <label>País de nacimiento *</label>
                            <p-select
                                [options]="countryList"
                                formControlName="paiNac"
                                placeholder="Seleccione el país de nacimiento"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                (onChange)="onCountryNacChange($event)"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div [miCol]="3" miFormField [miFormFieldError]="getErrorMessage('ciuNac', 'La ciudad de nacimiento es requerida')">
                            <label>Ciudad de nacimiento *</label>
                            <p-select
                                [options]="departmentCitiesNacList"
                                formControlName="ciuNac"
                                placeholder="Seleccione la ciudad de nacimiento"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div
                            [miCol]="3"
                            miFormField
                            [miFormFieldError]="getErrorMessage('fechaNac', 'La fecha de nacimiento es requerida')"
                        >
                            <label>Fecha de nacimiento *</label>
                            <p-datepicker
                                id="fechaNac"
                                formControlName="fechaNac"
                                dateFormat="dd/mm/yy"
                                showIcon="true"
                                placeholder="Selecciona una fecha"
                                [minDate]="fechaNacMinDate"
                                [maxDate]="fechaNacMaxDate"
                                [defaultDate]="fechaNacMaxDate"
                                appendTo="body"
                            ></p-datepicker>
                        </div>

                        <div [miCol]="3" miFormField [miFormFieldError]="getErrorMessage('genero', 'El género es requerido')">
                            <label>Género *</label>
                            <p-select
                                [options]="genderList"
                                formControlName="genero"
                                placeholder="Seleccione el género"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>

                        <div [miCol]="3" miFormField [miFormFieldError]="getErrorMessage('estadoCivil', 'El estado civil es requerido')">
                            <label>Estado civil *</label>
                            <p-select
                                [options]="civilStatusList"
                                formControlName="estadoCivil"
                                placeholder="Seleccione el estado civil"
                                [style]="{ width: '25rem' }"
                                [filter]="true"
                                [filterBy]="'label,id'"
                                optionLabel="label"
                                optionValue="id"
                                appendTo="body"
                            ></p-select>
                        </div>
                    </div>
                </p-accordion-content>
            </p-accordion-panel>
            <p-accordion-panel value="1" class="mb-2">
                <p-accordion-header>Datos de contacto</p-accordion-header>
                <p-accordion-content>
                    <div miForm>
                        <div [miCol]="4" miFormField [miFormFieldError]="getErrorMessage('celular', 'El número de celular es requerido')">
                            <label>Celular *</label>
                            <!-- <input pInputText formControlName="celular" placeholder="Número de celular" /> -->
                            <p-inputMask
                                id="celular"
                                formControlName="celular"
                                mask="999 999-9999"
                                placeholder="Celular"
                                slotChar=""
                                [unmask]="true"
                            />
                        </div>

                        <div [miCol]="4" miFormField>
                            <label>Teléfono </label>
                            <p-inputMask
                                id="telefono"
                                formControlName="telefono"
                                mask="999 999-9999"
                                placeholder="Teléfono"
                                slotChar=""
                                [unmask]="true"
                            />
                        </div>

                        <div [miCol]="4" miFormField [miFormFieldError]="getErrorMessage('correo', 'El correo es requerido')">
                            <label>Correo *</label>
                            <input pInputText formControlName="correo" placeholder="Correo electrónico" />
                        </div>
                    </div>
                </p-accordion-content>
            </p-accordion-panel>
        </p-accordion>
    </div>
</form>
